import React, { useCallback } from 'react'
import BoldCheckMark from './BoldCheckMark'
import { useTap } from '../hooks/useTap'

interface BoldCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  size?: number
}

/**
 * 굵은 네모 체크박스. 표식 하나가 곧 버튼인 자리에 쓴다.
 *
 * 줄 전체가 누르는 자리라면 이것 대신 줄에 [useTap] 을 걸고 [BoldCheckMark]
 * 만 그린다 — 둘 다 손짓을 받으면 한 번 누른 것이 두 번 처리된다.
 *
 * **`onClick` 이 아니라 손 떼는 순간 처리한다**([useTap]). 아이폰 웹뷰는
 * `click` 을 늦게 보내고, 빠르게 연달아 누르면 두 번째 탭을 확대 제스처
 * 후보로 묶어 삼킨다 — 켠 뒤 바로 다시 눌러도 안 꺼지는 이유였다.
 */
const BoldCheckbox: React.FC<BoldCheckboxProps> = ({
  checked,
  onChange,
  size = 26,
}) => {
  const handleTap = useCallback(() => onChange(!checked), [onChange, checked])
  const tap = useTap(handleTap)

  return (
    <button
      type="button"
      {...tap}
      className="border-none bg-transparent flex items-center justify-center cursor-pointer flex-shrink-0 p-0px"
      style={{ ...tap.style, width: size, height: size }}
      aria-pressed={checked}
      aria-label={checked ? '체크됨' : '체크 안됨'}
    >
      <BoldCheckMark checked={checked} size={size} />
    </button>
  )
}

export default BoldCheckbox
